// extracted by mini-css-extract-plugin
export default {"checkboxGroup":"styles_checkboxGroup__frQJS","label":"styles_label__AqiVX","checkboxGroupItems":"styles_checkboxGroupItems__O46yc"};